<template>
  <div>
    <v-tooltip :offset="[tooltipOffsetX, 0]" :content-class="tooltipContentClass">
      <template v-slot:activator="{ props }">
        <v-list-item
          class="left-menu__teams"
          :class="{
            'left-menu__teams--mini': mini,
            'left-menu__teams--mini_foreign': isForeignTeam && mini,
          }"
          v-bind="props"
          @click.stop="isOpenTeams = !isOpenTeams"
        >
          <div v-if="isForeignTeam" class="left-menu__teams-avatars">
            <div class="left-menu__teams-avatar left-menu__teams-avatar--back">
              <img alt="Аватар пользователя" :src="avatarSrc" />
            </div>
            <div class="left-menu__teams-avatar left-menu__teams-avatar--front">
              <img alt="Аватар владельца команды" :src="teamOwnerAvatarSrc" />
              <v-icon class="left-menu__teams-union" size="15" icon="union" />
            </div>
          </div>
          <div v-else class="ma-0" style="height: 24px">
            <img
              alt="Аватар пользователя"
              :src="avatarSrc"
              style="height: 24px; width: 24px; border-radius: 19px"
            />
          </div>
          <v-icon
            v-if="!isOpenTeams"
            size="13"
            class="left-menu__teams-chevron"
            :style="{
              marginLeft: chevronMarginLeft,
              right: mini ? '5px' : '',
            }"
            color="#7B7AA8"
            icon="chevronDown"
          />
          <v-icon
            v-else
            size="13"
            class="left-menu__teams-chevron"
            :style="{
              marginBottom: '1px',
              marginLeft: chevronMarginLeft,
              right: mini ? '5px' : '',
            }"
            color="#7B7AA8"
            icon="chevronUp"
          />
        </v-list-item>
      </template>
      <div class="d-flex flex-column">
        <span>{{ currentTeamName }}</span>
        <span>{{ currentTeamRole }}</span>
      </div>
    </v-tooltip>
    <TeamsMini
      v-if="isOpenTeams"
      v-my-custom-click-outside="closeTeamMenu"
      :mini="mini"
      :avatarSrc="avatarSrc"
      @close-team-menu="closeTeamMenu"
    />
  </div>
</template>

<script>
import avatarImg from "@/assets/img/avatar.png";
import TeamsMini from "@/components/Navigation/TeamsMini.vue";
import { useTeamStore, useUserStore } from "@/store/modules";

export default {
  name: "TeamsMenu",
  components: { TeamsMini },
  props: {
    mini: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isOpenTeams: false,
  }),
  computed: {
    userAvatar() {
      return useUserStore().user.avatar;
    },
    avatarSrc() {
      return this.userAvatar || avatarImg;
    },
    myTeam() {
      return useTeamStore().myTeam?.team?.slug;
    },
    selectedTeam() {
      return useTeamStore().selectedTeam?.team?.slug;
    },
    currentTeamName() {
      return useTeamStore().selectedTeam?.team?.name || "";
    },
    currentTeamRole() {
      if (!this.isForeignTeam) {
        return "Мой личный кабинет";
      }
      return useTeamStore().selectedTeam?.role?.name || "";
    },
    tooltipContentClass() {
      const base = "zarbo-tips__home-page tooltip-right tooltip-right__home-page zarbo-tips__teams";
      return this.mini ? base : `${base} zarbo-tips__teams--expanded`;
    },
    tooltipOffsetX() {
      return this.mini ? 0 : -6;
    },
    isForeignTeam() {
      // return true;
      return !!this.myTeam && !!this.selectedTeam && this.myTeam !== this.selectedTeam;
    },
    chevronMarginLeft() {
      return this.isForeignTeam ? "2px" : "10px";
    },
    teamOwnerAvatar() {
      return useTeamStore().selectedTeam?.team?.owner?.avatar;
    },
    teamOwnerAvatarSrc() {
      return this.teamOwnerAvatar || avatarImg;
    },
  },
  watch: {
    isOpenTeams(isOpen) {
      if (isOpen) {
        document.addEventListener("keydown", this.onKeydown);
      } else {
        document.removeEventListener("keydown", this.onKeydown);
      }
    },
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    closeTeamMenu() {
      this.isOpenTeams = false;
    },
    onKeydown(event) {
      if (event.key === "Escape" || event.keyCode === 27) {
        this.closeTeamMenu();
      }
    },
  },
};
</script>

<style lang="scss">
.left-menu__teams {
  width: 55px;
  height: 28px;
  min-height: 28px !important;
  border-radius: 14px;
  background: #3f3273;
  margin: 0;
  margin-right: 10px;
  padding-inline: 2px 4px !important;
  display: flex;
  align-items: center;
  --v-list-prepend-gap: 0px;

  > .v-list-item__overlay {
    opacity: 0 !important;
  }

  .v-list-item__content {
    padding: 0;
    display: flex;
    align-items: center;
    width: 100%;
  }

  &-chevron svg path {
    stroke: #7b7aa8;
  }
}

.left-menu__teams--mini {
  width: 48px;
  margin-right: 0;
  margin-bottom: 18px;
}
.left-menu__teams--mini_foreign {
  height: 34px;
  .left-menu__teams-avatar--back {
    top: -3px;
  }
  .left-menu__teams-avatar--front {
    left: -2px;
    top: 1px;
  }
  .left-menu__teams-chevron {
    right: 5px;
  }
}
.left-menu__teams.v-list-item {
  flex: none;
}

.left-menu__teams-avatars {
  position: relative;
  width: 34px;
  height: 34px;
  margin-top: 10px;
}

.left-menu__teams-avatar {
  position: absolute;
  width: 24px;
  height: 24px;
}

.left-menu__teams-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: block;
  object-fit: cover;
}

.left-menu__teams-avatar--back {
  left: 0;
  z-index: 1;
}

.left-menu__teams-avatar--front {
  width: 28px;
  height: 28px;
  top: -2px;
  left: 4px;
  z-index: 2;
  border: 2px solid #3f3273;
  border-radius: 14px;
}

.left-menu__teams-union {
  position: absolute !important;
  right: -1px;
  bottom: -1px;
}
.zarbo-tips__teams {
  opacity: 1 !important;
  border-radius: 10px !important;
  padding: 7px 12px !important;
  left: 68px !important;
}
.zarbo-tips__teams--expanded {
  top: 4px !important;
  left: 184px !important;
}
// TODO Куда то вынести походу надо глобально, подумаем
.tooltip-right__home-page::before {
  transform: translateY(-50%);
  background: url("../../assets/img/arrow-tips-home-page.svg") no-repeat center center;
}
</style>
